/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type BuyerChatRespVariantLazy_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatRespVariant_viewer">;
    readonly " $refType": "BuyerChatRespVariantLazy_viewer";
};
export type BuyerChatRespVariantLazy_viewer$data = BuyerChatRespVariantLazy_viewer;
export type BuyerChatRespVariantLazy_viewer$key = {
    readonly " $data"?: BuyerChatRespVariantLazy_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatRespVariantLazy_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerChatRespVariantLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerChatRespVariant_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '17bb123c678aafd4ac5d02e134522a97';
export default node;
